import { render, staticRenderFns } from "./SalidaArticulos.vue?vue&type=template&id=b71f0508&scoped=true"
import script from "./SalidaArticulos.vue?vue&type=script&lang=js"
export * from "./SalidaArticulos.vue?vue&type=script&lang=js"
import style0 from "./SalidaArticulos.vue?vue&type=style&index=0&id=b71f0508&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b71f0508",
  null
  
)

export default component.exports